import React from "react";

interface EmptyContentProps {
  isLoading: boolean;
  itemsLength: number;
  loadingMsg?: string|React.ReactNode;
  noDataMsg?: string|React.ReactNode;
}

const EmptyContent = ({ isLoading, itemsLength, loadingMsg, noDataMsg }: EmptyContentProps) => {
  if (!isLoading && itemsLength > 0) return null;

  return (
    <div
      className="no-content-wrapper"
    >
      <p className="text-light" style={{fontSize: '14px'}}>
        {/* {isLoading && (loadingMsg || "Loading...")} */}
        {!isLoading && itemsLength === 0 && (noDataMsg || "No Data Found")}
      </p>
    </div>
  );
};

export default EmptyContent;
